export const invListFilterConfig :DynamicFilterConfig[] = [
  {
    id: 'sku',
    query: 'sku',
    type: 'input',
    label: 'Product SKU',
  },
  {
    id: 'product',
    query: 'product',
    type: 'input',
    label: 'Product name',
  },

  {
    id: 'rfq_dept',
    query: 'rfq_dept',
    type: 'productDept',
    label: 'Product dept',
  },
  {
    id: 'date',
    query: 'date',
    type: 'date',
    label: 'Created Date',
  },
  {
    id: 'rfq_state',
    query: 'rfq_state',
    type: 'select',
    label: 'SKU status',
    options: [
      { value: 0, label: 'All' },
      { value: 1, label: 'New Quotes' },
      { value: 2, label: 'With Quotations' },
      { value: 3, label: 'Re-Quote Requests' },
      { value: 4, label: 'Price Negotiations' },
      { value: 5, label: 'With Sample Orders' },
      { value: 6, label: 'With Bulk Orders' },
    ],
  },
  {
    id: 'product_type_id',
    query: 'product_type_id',
    type: 'select',
    label: 'SKU type',
    options: [
      { value: 0, label: 'All' },
      { value: 1, label: 'Master/Parent SKUs' },
      { value: 2, label: 'Child SKUs' },
    ],
  },
  {
    id: 'starred',
    query: 'starred',
    type: 'select',
    label: 'Starred',
    options: [
      { value: 0, label: 'All' },
      { value: 1, label: 'Starred' },
      { value: 2, label: 'Not Starred' },
    ],
  },
  {
    id: 'qty_lvl',
    query: 'qty_lvl',
    type: 'select',
    label: 'Quantity level',
    options: [
      { value: 0, label: '' },
      { value: 1, label: 'Warning Level' },
      { value: 2, label: 'Re-order Level' },
      { value: 9, label: 'Warning or Re-order Level' },
    ],
  },
  {
    id: 'discontinued',
    query: 'discontinued',
    type: 'select',
    label: 'Discontinued',
    options: [
      { value: '2', label: 'All SKUs' },
      { value: '0', label: 'Active SKUs' },
      { value: '1', label: 'Discontinued SKUs' },
    ],
  },
  {
    id: 'warehouse_location',
    type: 'warehouseLocation',
    label: 'Warehouse/Location',
    query: ['warehouses', 'locations'],
  },
  {
    id: 'alternate_master',
    query: 'alternate_master',
    type: 'select',
    label: 'Alternate master SKUs',
    options: [
      { value: '-1', label: 'All SKUs' },
      { value: '1', label: 'Master SKUs Only' },
      { value: '2', label: 'Alternate Master SKUs Only' },
    ],
  },
  {
    id: 'channels',
    query: 'channels',
    type: 'channels',
    label: 'Channels',
    options: {
      multi: false,
    },
  },
  {
    id: 'clients',
    query: 'clients',
    type: 'clients',
    label: 'Clients',
    options: {
      multi: true,
    },
  },
  {
    id: 'tags',
    query: 'product_tags',
    type: 'tags',
    label: 'Tags',
  },
  {
    id: 'sourcingAssignee',
    query: 'sourcing',
    type: 'sourcingAssignee',
    label: 'Sourcing assignee',
  },
  {
    id: 'category',
    query: 'category_id',
    type: 'category',
    label: 'Category',
  },
  {
    id: 'subCategory',
    query: 'subcategory_id',
    type: 'subCategory',
    label: 'Sub category',
  },
  {
    id: 'internalUse',
    query: 'internal_use_only',
    type: 'toggle',
    label: 'Internal use only',
  },
  {
    id: 'lot_tracking',
    query: 'lot_tracking',
    type: 'select',
    label: 'Lot Tracking',
    options: [
      { value: '', label: 'All' },
      { value: 1, label: 'On' },
      { value: 0, label: 'Off' },
    ],
  },
  {
    id: 'disable_grouping',
    query: 'disable_grouping',
    type: 'toggle',
    label: 'Disable Grouping',
  },
  {
    id: 'sellable',
    query: 'sellable',
    type: 'select',
    label: 'Sellable',
    options: [
      { value: '', label: 'All' },
      { value: 1, label: 'Yes' },
      { value: 0, label: 'No' },
    ],
  },
];
